import { apolloClient } from '~/apollo-client';

import {
  Flex_FetchWaitlistOptionsQuery,
  Flex_FetchWaitlistOptionsQueryVariables,
} from '~/typings/graphql';
import { FETCH_WAITLIST_OPTIONS } from './fetch-waitlist-options.queries';

export type FetchWaitlistOptionsParams = {
  utilityId: number;
};

export type FetchWaitlistOptionsResponse = {
  utilityScrapeEligible: boolean;
  funnelTrack: string;
};

export const fetchWaitlistOptions = async (
  params: FetchWaitlistOptionsParams,
): Promise<FetchWaitlistOptionsResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchWaitlistOptionsQuery,
    Flex_FetchWaitlistOptionsQueryVariables
  >({
    query: FETCH_WAITLIST_OPTIONS,
    variables: {
      utilityId: params.utilityId,
    },
  });

  return {
    utilityScrapeEligible: data.utility.isutilityScraperEligible,
    funnelTrack: data.utility.funnelTrack,
  };
};
